import { FaqConstant } from "./FaqConstant";

const FaqAction = {};
FaqAction.getFaqCategories = (payload) => {
  return {
    type: FaqConstant.FAQ_CATEGORIES_SAGA,
    payload:payload
  };
};


FaqAction.updateFaq = (payload) => {
  return {
    type: FaqConstant.FAQ_UPDATE_SAGA,
    payload:payload
  };
};


FaqAction.PostFaqCategories = (payload) => {
  return {
    type: FaqConstant.POST_FAQ_CATEGORIES_SAGA,
    payload: payload,
  };
};

FaqAction.UdateFaqCategories = (payload) => {
  return {
    type: FaqConstant.UPDATE_FAQ_CATEGORIES_SAGA,
    payload: payload,
  };
};
///enable-disable category

FaqAction.FaqCategoriesStatusAction = ({ id, status }) => {
  return {
    type: FaqConstant.FAQ_CATEGORIES_STATUS_SAGA,
    payload: { id, status },
  };
};

FaqAction.FaqCategoriesDeleteAction = (id) => {

  return {
    type: FaqConstant.FAQ_CATEGORIES_DELETE_SAGA,
    payload: id,
  };
};

//faq store start here

FaqAction.getFaqAction = ({id ,status, category_id ,subcategory_id,content_type,search}) => {

  return {
    type: FaqConstant.FAQ_SAGA,
    payload:{id ,status, category_id ,subcategory_id,content_type,search}
  };
};


FaqAction.getFaqParentCategories = ({parent_id,content_type}) => {
  return {
    type: FaqConstant.FAQ_CATEGORIES_PARENT_SAGA,
    payload:{parent_id,content_type}
  };
};



FaqAction.postFaqAction = (payload) => {
  return {
    type: FaqConstant.FAQ_POST_SAGA,
    payload: payload,
  };
};

//faq delete

FaqAction.deleteFaq = (id) => {
  return {
    type: FaqConstant.FAQ_DELETE_SAGA,
    payload: id,
  };
};

//faq-keywords store start here

FaqAction.getFaqKeywordAction = ({question_id}) => {
  return {
    type: FaqConstant.GET_FAQ_KEYWORD_SAGA,
    payload:{question_id}
  };
};


FaqAction.postFaqKeywordAction = (payload) => {
  return {
    type: FaqConstant.POST_FAQ_KEYWORD_SAGA,
    payload: payload,
  };
};
FaqAction.updateFaqKeywordAction = (payload) => {
  return {
    type: FaqConstant.UPDATE_FAQ_KEYWORD_SAGA,
    payload: payload,
  };
};


FaqAction.deleteFaqKeyword = (id) => {
  return {
    type: FaqConstant.DELETE_FAQ_KEYWORD_SAGA,
    payload: id,
  };
};


export { FaqAction };
